import { useEffect, useRef } from "react";
import Image from "next/image";
import { twMerge } from "tailwind-merge";
import { Badge } from "flowbite-react";
import { register } from "swiper/element/bundle";
import ArrowButton from "components/General/ButtonGsfurn/ArrowButton";
import { printHTML } from "hooks/utils/formatter";

const Projects = ({ attrs }) => {
  const logoSwiperRef = useRef(null);

  const {
    titel,
    inhoud_linker_kolom,
    inhoud_rechter_kolom,
    projecten_selecteren,
    projecten_verbergen,
    slider_met_logos,
  } = attrs?.data || {};

  const displayProjects = projecten_verbergen === "0" && projecten_selecteren.filter(project => project?.thumbnail?.url);

  const logos = slider_met_logos?.length > 7
    ? slider_met_logos
    : Array(7).fill(slider_met_logos).flat();

  useEffect(() => {
    if (logos?.length === 0) {
      return;
    }

    register();

    const swiperParams = {
      slidesPerView: "auto",
      spaceBetween: 48,
      slidesOffsetBefore: 24,
      breakpoints: {
        768: {
          spaceBetween: 120,
          slidesOffsetBefore: 78,
        },
      },
      loop: true,
      autoplay: {
        delay: 0,
      },
      speed: 8000,
    };

    Object.assign(logoSwiperRef.current, swiperParams);
    logoSwiperRef.current.initialize();

  }, [slider_met_logos]);

  return (
    <section className="flex flex-col gap-3 px-4 mx-auto mb-16 md:mb-20 md:gap-6 xl:px-0 max-w-app">
      <div>
        {titel && <h2>{printHTML(titel)}</h2>}
        <div className="flex flex-col gap-8 md:gap-10">
          <div className="flex flex-col w-full gap-3 md:flex-row md:gap-6">
            {inhoud_linker_kolom &&
              <div className="w-full">
                {printHTML(inhoud_linker_kolom)}
              </div>
            }
            {inhoud_rechter_kolom &&
              <div className="w-full">
                {printHTML(inhoud_rechter_kolom)}
              </div>
            }
          </div>

          {displayProjects &&
            <div
              className={twMerge(
                "w-full grid grid-cols-1 gap-3 md:gap-6",
                displayProjects?.length > 1 && "md:grid-cols-2",
              )}
            >
              {displayProjects?.map(project => {
                return (project?.thumbnail?.url &&
                  <a
                    key={project?.id}
                    href={project?.permalink || ""}
                    title={project?.titel}
                    className="relative group/arrow w-full h-60 lg:h-[25rem] group"
                  >
                    <Image
                      src={project?.thumbnail?.url}
                      alt={project?.thumbnail?.alt}
                      fill
                      className="object-cover rounded-md lg:rounded-10"
                    />
                    <div className="absolute inset-0 w-full h-full transition-all duration-300 bg-black rounded-md lg:rounded-10 opacity-20 group-hover:opacity-80" />
                    <Badge
                      color="primary"
                      size="pill"
                      className="absolute top-8 left-6 lg:top-10 lg:left-10"
                    >
                      Project
                    </Badge>
                    <div className="absolute flex items-end justify-between bottom-8 lg:bottom-10 inset-x-6 lg:inset-x-10">
                      <div className="text-base font-black text-white lg:text-lg max-w-60">
                        {project?.title}
                      </div>
                      <ArrowButton />
                    </div>
                  </a>
                )
              })}
            </div>
          }
        </div>
      </div>

      {logos?.length > 0 &&
        <swiper-container
          init="false"
          ref={logoSwiperRef}
          className="w-full h-32 bg-white lg:h-44 rounded-10 !ease-linear"
          style={{ "--swiper-wrapper-transition-timing-function": "linear" }}
        >
          {logos?.map((logo, i) => (logo?.url &&
            <swiper-slide
              key={i}
              className="flex items-center h-full w-fit"
            >
              <Image
                src={logo?.url}
                alt={logo?.alt}
                width={250}
                height={100}
                className="w-full h-fit max-h-12 lg:max-h-20 max-w-32 lg:max-w-44"
              />
            </swiper-slide>
          ))}
        </swiper-container>
      }

    </section>
  );
};

export default Projects;